import React, { useEffect, useState } from "react";
import { Button, Header, Search, Segment } from "semantic-ui-react";
import { getSellerList } from "../../services/Seller";
import './SellerSearch.less'

const searchPlaceholder = 'Search For Pro (name/email)';
const SellerSearch = ({ onSellerChange }) => {
    const [value, setValue] = useState('');
    const [searchResult, setSearchResult] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [seller, setSeller] = useState({});
    const [timeOut, setTimeOutVar] = useState();

    useEffect(() => {
        if (timeOut) clearTimeout(timeOut);
        setSearchResult([]);
        if (value) {
            setTimeOutVar(setTimeout(() => {
                setLoading(true);
                getSellerList(value).then(({ data }) => {
                    if (data && data.length) {
                        setSearchResult(data)
                    }
                }).finally(() => {
                    setLoading(false);
                })
            }, 2000))
        }
    }, [value])

    useEffect(() => {
        onSellerChange(seller);
        setValue('')
    }, [seller])

    const handleResultSelect = (e, data) => {
        const seller = searchResult.find(s => s.sellerID == data.result.id);
        setSeller(seller);
    }

    return <>
        {!seller.sellerID ? 
        <>
        <div className="seller-search-header"> Search Seller</div>
        <Search
            loading={isLoading}
            onSearchChange={(e, data) => setValue(data.value)}
            results={searchResult.map(s => ({ id: s.sellerID, title: s.name + '(' + s.email + ')' }))}
            value={value}
            onResultSelect={handleResultSelect}
            placeholder={searchPlaceholder}
            className="main-search-input"
        /> </>: <Segment>
            <Header as="h2">{`${seller.name} (${seller.email})`}</Header>
            <Button className="seller-search-reset" onClick={() => setSeller({})}>Change Seller</Button>
        </Segment>
        }
    </>

}

export default SellerSearch;